import requests from './request';

// 注册时发送验证码
export const reqsendCodeOfRegister = (params)=>requests({url:'/customer/register/sendCode', method:'post', data:params});
// 注册接口
export const reqregister = (params)=>requests({url:'/customer/register/register', method:'post', data:params});
// 登录时发送验证码
export const reqsendCodeOfLogin = (params)=>requests({url:'/customer/login/sendCode', method:'post', data:params});
// 登录接口
export const reqlogin = (params)=>requests({url:'/customer/login/login', method:'post', data:params});
// 找回密码时发送验证码
export const reqsendCodeOfRetrievePwd = (params)=>requests({url:'/customer/login/sendCodeOfRetrievePwd', method:'post', data:params});
// 找回密码
export const reqretrievePwd = (params)=>requests({url:'/customer/login/retrievePwd', method:'post', data:params});
